import React, { useEffect } from 'react'
import './Menu.scss'

interface DropdownItem {
    icon: string,
    onClick?: Function,
    label: string
}

export default function Menu({ menuItems, setDropdownVisible, isFeatureService }: { menuItems: Array<DropdownItem>, setDropdownVisible: Function, isFeatureService: boolean }) {
    useEffect(() => {
        const handleClick = (e: any) => {
            if (e.target.closest('.dropdown') ||
                e.target.closest('.name-modal')) {
                // inside click
                return;
            }
            // outside click
            setDropdownVisible(false);
        };

        document.addEventListener("click", handleClick);

        return () => {
            document.removeEventListener("click", handleClick);
        };
    }, [setDropdownVisible]);


    return (
        <div className='menu'>
            {menuItems.map((item: any, index: number) => {
                if(isFeatureService && (item.label === 'Edit Color' || item.label === "Opacity" || item.label === "Download")) return '';
                return (
                    <div key={index} className='dropdown' onClick={item.onClick}>
                        <span className={`${item.icon} icon`} />
                        <p className='label'>{item.label}</p>
                    </div>
                )
            })}
        </div>
    )
}